import type { Map as MapType } from "maplibre-gl";
import { createAircraftMarker } from "./aircraft";
import type { SkopaCategory } from "../types";

const CATEGORIES: SkopaCategory[] = [
  "default",
  "commercial",
  "military",
  "helicopter",
  "uas-fixed-wing-jet",
  "uas-fixed-wing-prop",
  "uas-fixed-wing-generic",
  "uas-multi-rotor",
  "uas-generic",
  "usv",
  "ship-civilian",
  "ship-military",
];

// 🌟 MATRIX INTENTS: The prefix states your backend emits into 'sprite_key'
const INTENTS = ["friendly", "hostile", "neutral", "unknown"];

export async function registerAircraftSprites(map: MapType): Promise<void> {
  const loadPromises: Promise<void>[] = [];

  for (const category of CATEGORIES) {
    const promise = new Promise<void>((resolve) => {
      let svgString = createAircraftMarker(category).trim();

      // Upscale internal bounds for high-res crisp WebGL rendering
      svgString = svgString
        .replace(/width="32"/g, 'width="128"')
        .replace(/height="32"/g, 'height="128"');

      if (!svgString.includes("xmlns=")) {
        svgString = svgString.replace(
          "<svg",
          '<svg xmlns="http://www.w3.org/2000/svg"',
        );
      }

      const blob = new Blob([svgString], {
        type: "image/svg+xml;charset=utf-8",
      });
      const url = URL.createObjectURL(blob);
      const img = new Image();
      img.width = 128;
      img.height = 128;

      img.onload = () => {
        // 1. Register the raw name fallback ("military")
        if (!map.hasImage(category)) {
          map.addImage(category, img, { sdf: true });
        }

        // 2. 🌟 THE FIX: Register every dynamic lookup combination (e.g. "friendly-military")
        for (const intent of INTENTS) {
          const spriteKey = `${intent}-${category}`;
          if (!map.hasImage(spriteKey)) {
            map.addImage(spriteKey, img, { sdf: true });
          }
        }

        URL.revokeObjectURL(url);
        resolve();
      };

      img.onerror = (err) => {
        console.error(
          `[Sprite Engine Fail] Error building SDF: ${category}`,
          err,
        );
        URL.revokeObjectURL(url);
        resolve();
      };

      img.src = url;
    });

    loadPromises.push(promise);
  }

  await Promise.all(loadPromises);
  console.log(
    `[GameEngine Sprite Manager] Pre-loaded all asset intents to WebGL texture pipeline!`,
  );
}
